import React, { useState } from 'react';
import { globalStateSelector } from '../../state';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';
import './Header.css'
import { useAuth } from 'react-oidc-context';
import { Logo } from '../atoms';
import { MenuItem, MenuItemCommandEvent } from 'primereact/menuitem';
import { ProfileMenu } from './ProfileMenu';

interface Props {
}

export const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const auth = useAuth();
    const {t} = useTranslation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const items: MenuItem[] = [
        {
            label: t('menu.logoff'),
            icon: 'pi pi-sign-out',
            command(event: MenuItemCommandEvent) {
                auth.signoutRedirect({post_logout_redirect_uri: window.location.origin + '/'});
            }
        }
    ];
    return (
        <header className="bg-blue-800 text-white shadow-lg">
            <div className="container mx-auto px-4 py-3">
                <div className="flex justify-between items-center">
                    {/* Logo */}
                    <div className="flex">
                        <Logo className="mr-2"/>
                        <span className="text-2xl font-bold">PensioenZeker</span>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-8">
                        <a href="/" className="hover:text-blue-200 transition duration-300">Home</a>
                        <a href="#over-ons" className="hover:text-blue-200 transition duration-300">Over Ons</a>
                        <a href="#berekenen" className="hover:text-blue-200 transition duration-300">Bereken Uw Pensioen</a>
                        <a href="#contact" className="hover:text-blue-200 transition duration-300">Contact</a>
                        <a href="/mijn" className="hover:text-blue-200 transition duration-300">Mijn PensioenZeker</a>
                        <ProfileMenu menuItems={items}/>
                    </nav>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={toggleMenu}
                            className="text-white focus:outline-none"
                        >
                            <svg
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                {isMenuOpen ? (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                ) : (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isMenuOpen && (
                    <div className="md:hidden mt-4 pb-4">
                        <nav className="flex flex-col space-y-3">
                            <a href="#home" className="hover:text-blue-200 transition duration-300">Home</a>
                            <a href="#over-ons" className="hover:text-blue-200 transition duration-300">Over Ons</a>
                            <a href="#pensioenplannen" className="hover:text-blue-200 transition duration-300">Pensioenplannen</a>
                            <a href="#berekenen" className="hover:text-blue-200 transition duration-300">Bereken Uw Pensioen</a>
                            <a href="#contact" className="hover:text-blue-200 transition duration-300">Contact</a>
                        </nav>
                        <ProfileMenu menuItems={items}/>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;

// export const Header: React.FC<Props> = (props) => {
//     const {t} = useTranslation();
//     let globalState = useSelector(globalStateSelector);
//     const auth = useAuth();
//
//     const items: MenuItem[] = [
//         {
//             label: t('menu.logoff'),
//             icon: 'pi pi-sign-out',
//             command(event: MenuItemCommandEvent) {
//                 auth.signoutRedirect({post_logout_redirect_uri: window.location.origin + '/'});
//             }
//         }
//     ];
//
//
//     return (
//         <div className="col-12 p-0  mb-8 flex flex-column" style={{minHeight: '140px'}}>
//             <div className="w-full flex flex-row">
//                 <div className="col-2"></div>
//                 <div className="col-8 flex justify-content-center align-items-center">
//                     <a href="/"><Logo className=" w-18rem md:w-24rem h-auto align-self-center mb-2"/></a>
//                 </div>
//                 <div className="col-2 flex align-items-center justify-content-end">
//                     <ProfileMenu menuItems={items}/>
//                 </div>
//             </div>
//
//             <div style={{minHeight: '2px'}}>
//                 {globalState.isLoading && (<ProgressBar className="w-full" mode={globalState.isLoading ? "indeterminate" : "determinate"} value="100" showValue={false} color={'rgba(243,92,10,0.49)'} style={{height: '2px', backgroundColor: '#c8c8c8'}}></ProgressBar>)}
//             </div>
//         </div>
//     );
//
// };
